<template>
<div>
    <v-dialog
        v-model="dialog"
        max-width="600px"
        fullscreen
    >
      <v-card tile :disabled="loading">
        <BarTitle title="Historico de Equipe" @close="dialog = false"></BarTitle>
        <v-card-text>
            <v-card outlined>
            <v-data-table
                :loading="loading"
                :headers="headers"
                :items="historics"
                class="elevation-0"

            >
            <template v-slot:item.metering="{ item }">
                {{ item.metering_mop.metering_n }}
            </template>
            <template v-slot:item.period="{ item }">
                {{ formatDate(item.metering_mop.physical_progress.date_start) }} - {{ formatDate(item.metering_mop.physical_progress.date_end) }}
            </template>
            <template v-slot:item.action="{ item }">
                <v-row>
                    <v-col class="text-right" >
                        <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          color="secondary"
                          v-bind="attrs"
                          v-on="on"
                          @click="showMeteringMopTeam(item)"
                        >
                          <v-icon>mdi-eye</v-icon>
                        </v-btn>
                      </template>
                      <span>Visualizar Equipe</span>
                    </v-tooltip>
                    </v-col>
                </v-row>

            </template>

            </v-data-table>
            </v-card>
        </v-card-text>
        <v-card-actions></v-card-actions>
      </v-card>

    </v-dialog>

    <DialogMeteringMopManagerTeam
      v-model="dialogManagerTeam"
      :metering_mop_id="metering_mop_id"
      :team="team"
      :no_edit="true"
    ></DialogMeteringMopManagerTeam>

</div>
</template>

<script>
import BarTitle from "@/pages/Components/BarTitle.vue";
import DialogMeteringMopManagerTeam from "./DialogMeteringMopManagerTeam.vue";
import { mapActions } from "vuex";
export default {
    props: {
      value: {
        type: Boolean,
        default: false,
      },
      team: {
        type: Object,

      },
    },
    components: {
        BarTitle,
        DialogMeteringMopManagerTeam,
    },
    data() {
        return {
            dialogManagerTeam: false,
            metering_mop_id: null,

            loading: false,
            dialog: false,
            historics:[],
            headers:[
                { text: 'MEDIÇÃO', value: 'metering' },
                { text: 'PERÍODO', value: 'period' },
                { text: '', value: 'action' },
            ],

        };
    },
    watch: {
        value(val) {
            this.dialog = val;
        },
        dialog(val) {
          this.$emit('input',val);
            if(val){
               this.loadHistoric();
            }
        },
    },
    computed: {},
    methods: {
        ...mapActions('MeteringMop', ['getHistoricTeam']),
        loadHistoric(){
            this.loading = true;
            this.getHistoricTeam(this.team.id).then((response)=>{
                this.historics = response.data.data;
            }).finally(()=>{
                this.loading = false;
            });
        },
        showMeteringMopTeam(item){
            console.log(item)
            this.team = item.team;
            this.metering_mop_id = item.metering_mop_id;
            this.dialogManagerTeam = true;
        },
        formatDate(date) {
            if (date) {
                let date_split = date.split("-");
                return date_split[2] + "/" + date_split[1] + "/" + date_split[0];
            }
        return "";
        },
    },
}
</script>

<style scoped>

</style>
